import {Font} from '@pepsico-ds/ui';
import {TextInput} from '@/components/atoms';
import {useIntl} from 'react-intl';

const formatUpperRange = (num, isLast) => {
  if (num === null || num === undefined) return isLast ? 'Infinite' : '-';
  return new Intl.NumberFormat('en-US').format(num);
};

const formatLowerRange = (num) => {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('en-US').format(num);
};

export const TierTable = ({
  tiers,
  currencyCode,
  isEditMode,
  errors,
  handleUpperRangeChange
}) => {
  const {formatMessage} = useIntl();

  const blockDecimalAndNegative = (e) => {
    if (e.key === '-' || e.key === '.' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  };

  const blockDecimalAndNegativePaste = (e) => {
    const pasted = e.clipboardData?.getData('text') || '';
    if (
      pasted.includes('-') ||
      pasted.includes('.') ||
      pasted.includes('e') ||
      pasted.includes('E')
    ) {
      e.preventDefault();
    }
  };
  return (
    <div className='tier-table mt-6'>
      <div className='tier-table-header'>
        <div className='tier-table-cell tier-table-cell--tier'>
          <Font variant='bold' size='small' textColorClass='text-white'>
            {formatMessage({
              id: 'CLUB_PLUS.TIER_CONFIGURATIONS_TABLE_COLUMN_TIER'
            })}
          </Font>
        </div>
        <div className='tier-table-cell tier-table-cell--range'>
          <Font variant='bold' size='small' textColorClass='text-white'>
            {formatMessage(
              {
                id: 'CLUB_PLUS.TIER_CONFIGURATIONS_TABLE_COLUMN_LOWER_RANGE'
              },
              {currency: currencyCode}
            )}
          </Font>
        </div>
        <div className='tier-table-cell tier-table-cell--range'>
          <Font variant='bold' size='small' textColorClass='text-white'>
            {formatMessage(
              {
                id: 'CLUB_PLUS.TIER_CONFIGURATIONS_TABLE_COLUMN_UPPER_RANGE'
              },
              {currency: currencyCode}
            )}
          </Font>
        </div>
      </div>

      {tiers.map((tier, index) => {
        const isLast = index === tiers.length - 1;
        const error = errors[index];

        return (
          <div key={tier.tierID} className='tier-table-row'>
            <div className='tier-table-cell tier-table-cell--tier'>
              <div className='flex items-center gap-2'>
                <span
                  className='tier-color-dot'
                  style={{backgroundColor: `#${tier.color}`}}
                />
                <Font
                  variant='regular'
                  size='small'
                  textColorClass='text-white'>
                  {tier.name}
                </Font>
              </div>
            </div>
            <div className='tier-table-cell tier-table-cell--range'>
              <Font variant='regular' size='small' textColorClass='text-white'>
                {formatLowerRange(tier.lowerRange)}
              </Font>
            </div>
            <div className='tier-table-cell tier-table-cell--range'>
              {isEditMode && !isLast ? (
                <div className='tier-input-wrapper'>
                  <TextInput
                    value={
                      tier.upperRange !== null && tier.upperRange !== undefined
                        ? tier.upperRange
                        : ''
                    }
                    onChange={(val) => handleUpperRangeChange(index, val)}
                    label={''}
                    type='number'
                    isDark={true}
                    error={error}
                    hideFeedbackIcon={true}
                    className='tier-range-input'
                    handleKeyDown={blockDecimalAndNegative}
                    onPaste={blockDecimalAndNegativePaste}
                  />
                </div>
              ) : (
                <Font
                  variant='regular'
                  size='small'
                  textColorClass='text-white'>
                  {formatUpperRange(tier.upperRange, isLast)}
                </Font>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
